<template>
  <div id="groupOfCharges" class="col-12 p-0">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-create-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              Agregar Grupo de Cargos
            </h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 mb-4 input-vp2"
              placeholder="Nombre de la Grupo de Cargos"
            />

            <div style="display: flex" class="mt-4">
              <button
                :disabled="nameLN === ''"
                @click="nextStep1GC('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="$bvModal.hide('modal-create-gc')"
              >
                <span class="cta">Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-create2-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 mb-2 font-weight-bold">
              ¿Estás seguro de guardar el Grupo de Cargos?
            </h3>
            <p class="pt-2 mb-4">
              <b>Nombre:</b> <span class="text-uppercase">{{ nameLN }}</span>
            </p>

            <div style="display: flex" class="pt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep1GC('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep1GC('save')"
                type="button"
                class="button-primary enviar-mensaje ml-4"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL PROCESO EXITOSO -->

        <b-modal id="modal-success-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>

            <button
              @click="$bvModal.hide('modal-success-gc')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL PROCESO FALLIDO -->

        <b-modal v-if="error.trace" id="modal-fail-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/close.svg"
              width="20%"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.trace.message[0] }}</p>
            <button
              class="mt-2 mb-5 col-6 btn btn-danger"
              @click="$bvModal.hide('modal-fail-gc')"
            >
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">
              Editar Grupo de Cargos
            </h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre del Grupo de Cargos"
            />
            <div style="display: flex" class="mt-4">
              <button
                :disabled="checkEdit"
                @click="nextStep2LN('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2LN('nextD')"
              >
                <img src="@/assets/images/icons/delete_trash_white.svg" />
                <span class="cta ml-2"> Borrar Grupo</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL EDICIÓN LINEA DE NEGOCIO -->

        <b-modal id="modal-edit2-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de modificar el Grupo de Cargos?
            </h3>
            <p class="pt-2">
              <b>Nombre:</b>
              {{ nameLN }}
            </p>
            <div style="width: 100%; display: flex" class="mt-4">
              <button
                type="button"
                class="button-secundary"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>

              <button
                @click="nextStep2LN('edit')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR LINEA DE NEGOCIO -->

        <b-modal id="modal-delete-gc" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de eliminar el Grupo de Cargos?
            </h3>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <b>Nombre:</b>
              {{ nameLN }}
            </p>

            <div style="display: flex" class="mt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta">No borrar</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2LN('delete')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                  alt=""
                />
                <span class="cta ml-2"> Borrar Grupo</span>
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Grupo de Cargos-->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory
          text="Agregar Grupo de Cargos +"
          @nuevo="create"
        ></AddCategory>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Grupos de Cargos</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input
                type="search"
                placeholder="Buscar un Grupo de cargos"
                aria-label="Buscar un Grupo de cargos"
                autocomplete="off"
                class="form-control body_regular"
                v-model="filter"
                style="border: 0px"
                @keydown="startTipyng()"
                @keyup="finishTipyng()"
              />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="editGroupOfCharges(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
            >
              <Pagination
                :data="groupOfCharges.data"
                :limit="10"
                @pagination-change-page="loadRows"
              >
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import AddCategory from "@/components/core/button/add-category.vue";
import Pagination from "laravel-vue-pagination";
export default {
  name: "groupOfCahrges",
  components: {
    SelectSettings,
    Pagination,
    AddCategory,
  },
  data() {
    return {
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      filter: "",
      datatable: {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.loadRows();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "groupOfCharges",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actGroupOfCharges",
      "actSaveGroupOfCharges",
      "actUpdateGroupOfCharges",
      "actDeleteGroupOfCharges",
      "actSetMessage",
      "actSetError",
    ]),

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.loadRows();
      }, 500);
    },

    create() {
      this.nameLN = "";
      this.$root.$emit("bv::show::modal", "modal-create-gc");
    },

    nextStep1GC(x) {
      let data = {
        name: this.nameLN,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-create-gc");
          this.$root.$emit("bv::show::modal", "modal-create2-gc");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-gc");
          this.$root.$emit("bv::show::modal", "modal-create-gc");
          break;
        case "save":
          this.actSaveGroupOfCharges(data).then(() => {
            if (this.error.data) {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-create2-gc");
              this.$root.$emit("bv::show::modal", "modal-fail-gc");
              this.loadRows();
            } else {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-create2-gc");
              this.$root.$emit("bv::show::modal", "modal-success-gc");
              this.loadRows();
            }
          });

          break;
        default:
      }
    },
    loadRows(page = 1) {
      this.datatable = {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Grupos de Cargos",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
      ];

      let data = {};
      data = {
        page: page,
        filter: this.filter,
      };

      this.actGroupOfCharges(data).then(() => {
        this.groupOfCharges.data.data.forEach((x) => {
          this.datatable.rows.push({
            id: x.id,
            name: x.name,
          });
        });
      });
    },
    editGroupOfCharges(row) {
      this.nameLN = row.name;
      this.indexRow = row.id - 1;
      this.$root.$emit("bv::show::modal", "modal-edit-gc");
    },
    nextStep2LN(x) {
      let id = this.indexRow + 1;
      let data = {
        id: id,
        name: this.nameLN,
      };

      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit-gc");
          this.$root.$emit("bv::show::modal", "modal-edit2-gc");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2-gc");
          this.$root.$emit("bv::hide::modal", "modal-delete-gc");
          this.$root.$emit("bv::show::modal", "modal-edit-gc");
          break;
        case "edit":
          this.actUpdateGroupOfCharges(data)
            .then(() => {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-edit2-gc");
              this.$root.$emit("bv::show::modal", "modal-success-gc");
              this.loadRows();
            })
            .catch((response) => {
              this.nameLN = "";
              this.actSetMessage(response).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-edit2-gc");
                this.$root.$emit("bv::show::modal", "modal-fail-gc");
                this.loadRows();
              });
            });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit-gc");
          this.$root.$emit("bv::show::modal", "modal-delete-gc");
          break;
        case "delete":
          this.actDeleteGroupOfCharges(id)
            .then(() => {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-delete-gc");
              this.$root.$emit("bv::show::modal", "modal-success-gc");
              this.loadRows();
            })
            .catch((error2) => {
              let error = {
                trace: {
                  message: [error2.response.data.message],
                },
              };
              this.nameLN = "";
              this.actSetError(error).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-delete-gc");
                this.$root.$emit("bv::show::modal", "modal-fail-gc");
                this.loadRows();
              });
            });
          break;
        default:
      }
    },
  },
};
</script>

<style lang="scss">
#groupOfCharges {
  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }
  .custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .btn-create {
    padding: 12px;
    border-radius: 20px;
    background-color: #269887;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;

    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .btn-create:hover {
    background-color: #27a391;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  }
  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    .theading {
      padding: 15px 15px;
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    tbody tr td {
      padding: 15px 15px;
      border-radius: 10px;
      cursor: pointer;
    }
    tbody tr td:hover {
      background-color: #f5f5f5;
    }
  }
}
.modal-content {
  .modal-header {
    border: none;
  }
  .input-vp2,
  /*button {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }*/
  .btn-outline-success {
    border-radius: 20px;
    color: #269887;
    border-color: #269887;
  }
  .btn-outline-success:hover,
  .btn-success {
    color: white;
    background-color: #269887;
    border-color: #269887;
  }
  .btn-success:hover {
    background-color: #27a391;
  }
  .regular {
    background-color: white;
    border: none;
    color: #269887;
  }
  .delete {
    background-color: white;
    border: none;
    color: #da1414;
  }
  h3 {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
  }
}
</style>